import { useState, useCallback } from "react";

export function useSaveConfirmation<T extends string>() {
  const [lastSavedSection, setLastSavedSection] = useState<T | null>(null);

  // Call this after a successful save
  const showConfirmation = useCallback((section: T) => {
    setLastSavedSection(section);
  }, []);

  // Call this on any field edit
  const clearConfirmation = useCallback(() => {
    setLastSavedSection(null);
  }, []);

  return { lastSavedSection, showConfirmation, clearConfirmation };
}